import { SET_FILTERS, SET_FILTER, CLEAR_FILTERS, GET_FILTER_ENTITIES } from '../actiontypes';
import Env from '../../util/env';
import {serviceURL} from '../../util/uiconstants';
import {FilterEntityConfiguration} from '../../components/Common/CommonConfig/Config';

export const setFilters = (key, filter, value) => {
	return {
		type: SET_FILTERS,
		key,
		filter,
		value
	};
};

const buildUrl = (entityType, entityFilter) => {
	let endpoint;

	if (entityType) {
		endpoint = FilterEntityConfiguration[entityType].endpoint;
	}

	let url;
	if (endpoint) {
		if (typeof endpoint !== 'function') {
			const [entityId, field] = getEntityId(entityFilter, entityType);
			if (entityId) {
				if (!endpoint.endsWith('/')) {
					endpoint += '/';
				}

				endpoint += entityId;
			}

			url = new URL(endpoint, Env.getBaseURL(serviceURL, entityFilter.engagementId));

			if (entityFilter) {
				Object.entries(entityFilter).forEach((item) => {
					if (item[0] !== 'engagementId' && item[0] !== field && item[1]) {
						if (Array.isArray(item[1])) {
							for (let i = 0; i < item[1].length; i++) {
								const element = item[1][i];

								url.searchParams.append(item[0], element);
							}
						} else {
							url.searchParams.append(item[0], item[1]);
						}
					}
				});
			}
		} else {
			url = new URL(endpoint(entityFilter), Env.getBaseURL(serviceURL, entityFilter.engagementId));
		}

		return url.toString();
	}
};

const getEntityId = (entityFilter, entityType) => {
	if (entityFilter) {
		const fields = [`${entityType}Id`, `id`];

		let i = 0,
			found = false,
			entityId,
			field;

		while (i < fields.length && !found) {
			field = fields[i];
			entityId = entityFilter[field];
			if (entityId) {
				found = true;
			}
			i++;
		}

		return [entityId, field];
	}
};

export const getFilterEntities = (key, name, entityType, entityFilter, dataMapping, apiCall = true, data) => {
	return {
		type: GET_FILTER_ENTITIES,
		key,
		name,
		entityType,
		dataMapping,
		resolve: true,
		apiCall,
		response: data,
		meta: apiCall
			? {
					api: {
						url: buildUrl(entityType, entityFilter),
						method: 'GET'
					}
			  }
			: null
	};
};

export const clearFilters = (key, parentName = undefined, selectedKey = undefined) => {
	return {
		type: CLEAR_FILTERS,
		key,
		parentName,
		selectedKey
	};
};

export function setFilter(parentName, filterKey, filterItemName, value) {
	return {
		type: SET_FILTER,
		parentName,
		filterKey,
		filterItemName,
		value
	};
}
